import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { PanelBody, SelectControl, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl, ToggleControl, PanelRow, __experimentalAlignmentMatrixControl as AlignmentMatrixControl } from "@wordpress/components";


import { BtnGroup, HelpPanel, ItemsPanel, Label } from '../../../../../../bpl-tools/Components';
import { BDevice } from '../../../../../../bpl-tools/Components/Deprecated';

import { pxUnit, vhUnit, perUnit, indicatorOption, sliderOption, animationOptions, animationFreeOptions, contentPosition, arrowStyles, indicatorOptions, titleTag } from '../../../../Const/options';

import { checkDirection } from '../../../../Const/functions';
import { BControlPro } from '../../../../../bplugins_sdk/src/components/v1';

import ButtonGroupController from '../ButtonGroupController';

import Item from '../Item';
import icons from '../../../../Const/icons';

const General = ({ isPremium, attributes, setAttributes, activeIndex, setActiveIndex, title, titleFCaption, slideInnerGap, options, height, sliderHeight, slideInnerGapDevice, animation, position, arrowStyle, isMouseWheel, isArrowFollowSlide, isMouseDrag, isLazyLoad, direction, setProModalOpen, updateObject, arrow, indicator, }) => {

    const [device, setDevice] = useState('desktop');
    const [gapDevice, setGapDevice] = useState('desktop');
    const premiumProps = { isPremium, setOpen: setProModalOpen }
    const itemsProps = { attributes, setAttributes, arrKey: 'sliders', activeIndex, setActiveIndex, premiumProps }

    return <>
        <HelpPanel slug="b-slider" docsLink="https://bplugins.com/docs/b-slider" />

        <PanelBody className='bPlPanelBody' title={__('Slides', 'slider')}>
            <ItemsPanel {...itemsProps} newItem={{
                image: { id: null, url: '', alt: '', title: '' },
                action: 'none',
                link: '',
                caption: ''
            }} ItemSettings={Item} itemLabel='Slide' design={isPremium ? 'sortable' : 'all'} />
        </PanelBody>

        <PanelBody className='bPlPanelBody' title={__('Title', 'slider')} initialOpen={false}>
            <BControlPro label={__('Tag', 'Slider')} options={titleTag} labelPosition='left' value={title?.tag || 'h5'} onChange={val => updateObject('title', 'tag', val)} isPremium={isPremium} Component={SelectControl} setOpen={setProModalOpen} />

            <ToggleControl className='mt10' label={__('Import Title From Media Caption', 'slider')} checked={titleFCaption} onChange={(val) => setAttributes({ titleFCaption: val })} />
        </PanelBody>

        <PanelBody className='' title={__('Layout Settings', '')} initialOpen={false}>

            <PanelRow className='mt20'>
                <Label mt='0'>{__('Gap:', 'slider')}</Label>
                <BControlPro device={gapDevice} onChange={val => setGapDevice(val)} isPremium={isPremium} Component={BDevice} setOpen={setProModalOpen} />
            </PanelRow>

            <BControlPro className='mb20' label={__('Left/Right Inner Gap', 'slider')} labelPosition='left' value={slideInnerGapDevice[gapDevice] || slideInnerGap} onChange={val => { setAttributes({ slideInnerGapDevice: { ...slideInnerGapDevice, [gapDevice]: val } }) }} units={[pxUnit(400), vhUnit(30)]} isResetValueOnUnitChange={true} beforeIcon='grid-view' isPremium={isPremium} Component={UnitControl} setOpen={setProModalOpen} />

            <BControlPro className='mt20' label={__('Slide Direction', 'slider')} labelPosition='left' value={direction} options={sliderOption} onChange={(val) => { setAttributes({ direction: val }) }} isPremium={isPremium} Component={SelectControl} setOpen={setProModalOpen} />

            {/* Height define option  */}
            <PanelRow className='mt20'>
                <Label mt='0'>{__('Height:', 'slider')}</Label>
                <BControlPro label={__('Slider Height')} device={device} onChange={val => setDevice(val)} isPremium={isPremium} Component={BDevice} setOpen={setProModalOpen} />
            </PanelRow>

            <UnitControl className='mb20' label={__('Slider Height', 'slider')} labelPosition='left' value={sliderHeight[device] || height} onChange={val => { setAttributes({ sliderHeight: { ...sliderHeight, [device]: val } }) }} units={[pxUnit(400), vhUnit(30)]} isResetValueOnUnitChange={true} beforeIcon='grid-view' />

            <PanelRow>
                {isPremium ?
                    <><Label>{__('Content Position:', 'slider')}</Label>
                        <AlignmentMatrixControl value={position?.top || position} onChange={val => setAttributes({ position: val })} />
                    </> :
                    <SelectControl label={__('Content Position:', 'slider')} labelPosition='left' value={position} options={contentPosition} onChange={(val) => { setAttributes({ position: val }) }} />
                }
            </PanelRow>

            <BControlPro label={__('Arrow Style:', 'slider')} value={arrowStyle} onChange={(arrowStyle) => setAttributes({ arrowStyle })} isPremium={isPremium} setOpen={setProModalOpen} Component={ButtonGroupController} options={arrowStyles} />
        </PanelBody>

        <PanelBody className='' title={__('Slider Options', 'slider')} initialOpen={false}>

            {isPremium ?
                <SelectControl label={__('Animation/Effect:', 'slider')} labelPosition='side' value={animation} onChange={(val) => setAttributes({ animation: val })} options={animationOptions} />
                :
                <>
                    <PanelRow>
                        <Label className='mb0'>{__('Animation/Effect:', 'slider')}</Label>
                        <BtnGroup value={animation} onChange={val => setAttributes({ animation: val })} options={animationFreeOptions} />
                    </PanelRow>
                </>
            }

            <ToggleControl className='mt20' label={__('Autoplay', 'slider')} checked={options.ride} onChange={(value) => updateObject('options', 'ride', value)} />

            {options.ride && <>
                <NumberControl className='mb10' label={__('Interval(ms)', 'slider')} labelPosition='left' value={options.interval} onChange={(value) => updateObject('options', 'interval', parseInt(value))} min={1000} max={10000} />

                <ToggleControl className='mt10' label={__('Pause on Mouse over', 'slider')} checked={options.pause} onChange={(value) => updateObject('options', 'pause', value)} />
            </>}

            <ToggleControl className='mt20' label={__('Show Arrow/Navigation', 'slider')} checked={arrow.visibility} onChange={(value) => { updateObject('arrow', 'visibility', value) }} />

            <ToggleControl className='mt10' label={__('Show Indicators/Pagination', 'slider')} checked={indicator.visibility} onChange={(value) => updateObject('indicator', 'visibility', value)} />

            <BControlPro className='mt20' label={__('Slide On MouseWheel', 'slider')} checked={isMouseWheel} onChange={(val) => setAttributes({ isMouseWheel: val })} isPremium={isPremium} Component={ToggleControl} setOpen={setProModalOpen} />

            <BControlPro className='mt10 marginLeft' label={__('Arrow Follow Mouse', 'slider')} checked={isArrowFollowSlide} onChange={(val) => setAttributes({ isArrowFollowSlide: val })} isPremium={isPremium} Component={ToggleControl} setOpen={setProModalOpen} />
            <small className='warning'>{icons.warning}Only work frontEnd and button will not work</small>

            <BControlPro className='mt10 marginLeft' label={__('Slide on Mouse Drag', 'slider')} checked={isMouseDrag} onChange={(val) => setAttributes({ isMouseDrag: val })} isPremium={isPremium} Component={ToggleControl} setOpen={setProModalOpen} />
            <small className='warning'>Arrow Follow Mouse enable slide on mouse drag not working</small>

            <BControlPro className='mt20' label={__('Lazy Load Enable', 'slider')} checked={isLazyLoad} onChange={(val) => setAttributes({ isLazyLoad: val })} isPremium={isPremium} Component={ToggleControl} setOpen={setProModalOpen} />
        </PanelBody>

        {indicator.visibility && <PanelBody className='bPlPanelBody' title={__('Indicators', 'slider')} initialOpen={false}>
            <BControlPro className='mt10' label={__('Type', 'slider')} value={indicator?.type} labelPosition='left' onChange={(val) => setAttributes({
                indicator: {
                    ...indicator,
                    type: val,
                    width: 'image' === val ? '80px' : '30px',
                    height: 'image' === val ? '80px' : '3px',
                    radius: 'image' === val ? '50%' : '0px',
                    moveFromEdge: 'image' === val ? '50%' : '-15px',
                }
            })} options={indicatorOption} isPremium={isPremium} Component={SelectControl} setOpen={setProModalOpen} />

            {isPremium && <PanelRow className='mt20 mb10'>
                <Label className='mb0'>{__('Position:', 'slider')}</Label>
                <AlignmentMatrixControl value={indicator.position}
                    onChange={val => {
                        setAttributes({
                            indicator: { ...indicator, position: val, ...checkDirection(val) },
                        })
                    }}
                />
            </PanelRow>}

            <BControlPro label={__('Direction', 'slider')} labelPosition='side' value={indicator.direction} onChange={(val) => { updateObject('indicator', 'direction', val) }} options={indicatorOptions} isPremium={isPremium} Component={SelectControl} setOpen={setProModalOpen} />

            {
                indicator.position !== 'center center' && <>
                    <BControlPro className='mb20 mt20 marginLeft' label={__('Move From Edge', 'slider')} labelPosition='left' value={indicator.moveFromEdge} onChange={(val) => updateObject('indicator', 'moveFromEdge', val)} units={[pxUnit(40), perUnit(50)]} isResetValueOnUnitChange={true} isPremium={isPremium} Component={UnitControl} setOpen={setProModalOpen} />
                    <small className='warning'>{__('Use a negative or positive value to move in or out.', 'slider')}</small>
                </>
            }

        </PanelBody>}

    </>

}
export default General;